import { render, staticRenderFns } from "./Jugadores.vue?vue&type=template&id=167d0d2d&"
import script from "./Jugadores.vue?vue&type=script&lang=js&"
export * from "./Jugadores.vue?vue&type=script&lang=js&"
import style0 from "./Jugadores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports